import { render, staticRenderFns } from "./two.vue?vue&type=template&id=f6305cf6&scoped=true&"
import script from "./two.vue?vue&type=script&lang=ts&"
export * from "./two.vue?vue&type=script&lang=ts&"
import style0 from "./two.vue?vue&type=style&index=0&id=f6305cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6305cf6",
  null
  
)

export default component.exports